import React, { useContext } from 'react';
import { RadioGroup, Container } from '@mui/material';

import SelectionWithDescription from '@/operator/components/general/selection/SelectionWithDescription';
import EditUserContext from '../../context/EditUserContext';
import EditUserActions from '../Actions/index';
import { FirestoreUserRole } from 'generated/graphql';

const EditUserRole: React.FC = () => {
    const {
        selectedRole,
        setSelectedRole,
        fetchedQualityUser,
        updateUserRole,
        enableButtons,
    } = useContext(EditUserContext);

    const fetchedUserRole = fetchedQualityUser.roles.includes(
        FirestoreUserRole.OrganizationAdmin,
    )
        ? FirestoreUserRole.OrganizationAdmin
        : FirestoreUserRole.User;
    const hasRoleChanged = selectedRole !== fetchedUserRole;

    return (
        <Container>
            {hasRoleChanged && (
                <EditUserActions
                    onClickSaveChanges={() => updateUserRole()}
                    onClickCancelChanges={() => {
                        setSelectedRole(fetchedUserRole);
                    }}
                    disableButtons={!enableButtons}
                />
            )}
            <RadioGroup
                sx={{
                    backgroundColor: 'white',
                    padding: '20px',
                    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 4px 0px',
                    m: 2,
                }}
            >
                <SelectionWithDescription
                    label={'Standard User'}
                    description={'Access to Quality as regular user.'}
                    checked={selectedRole === FirestoreUserRole.User}
                    onChangeFn={() => setSelectedRole(FirestoreUserRole.User)}
                />
                <SelectionWithDescription
                    label={'Organization Admin'}
                    description={
                        'Complete control over Quality. The ability to upgrade accounts and access billing details.'
                    }
                    checked={
                        selectedRole === FirestoreUserRole.OrganizationAdmin
                    }
                    onChangeFn={() =>
                        setSelectedRole(FirestoreUserRole.OrganizationAdmin)
                    }
                />
            </RadioGroup>
        </Container>
    );
};

export default EditUserRole;
